import React, { useState } from "react";
import "antd/dist/antd.css";
import { Col, Button } from "antd";
import styles from "./DashBoard.module.scss";
import textStyles from "../../components/DashBoard/BookingSummary/BookingSummary.module.scss";
import { leftOutlinedIcon } from "../../assets/images";
import EllipsisText from "../../helpers/EllipsisText/EllipsisText";

type PersonActionButtonsProps = {
  handleBackToServiceUser: () => void;
  selectedPersonId: string | null;
  selectedServiceUserName: string;
};

const DashBoardPersonActionButtons: React.FC<PersonActionButtonsProps> = ({
  handleBackToServiceUser,
  selectedPersonId,
  selectedServiceUserName,
}) => {
  return (
    <>
      <Col
        span={16}
        className={`${styles.personActionBtns} ${textStyles.normalText20}`}
      >
        <Button
          className={styles.leftOutlinedBtnStyle}
          onClick={handleBackToServiceUser}
        >
          <img
            className={styles.userLeftOutlinedIconStyle}
            src={leftOutlinedIcon}
            alt="navigate_back_icon"
          />
        </Button>

        {selectedPersonId ? (
          <EllipsisText
            text={selectedServiceUserName}
            maxVisibleTextLength={10}
          />
        ) : (
          "All Services"
        )}
      </Col>
    </>
  );
};

export default DashBoardPersonActionButtons;
